<kpi4me-select-element
  class="form-field-no-padding"
  [formControlElement]="textFormControl"
  [editEnabled]="false"
  [deleteEnabled]="false"
  [data]="selectElementData"
  [compareWith]="compareWith"
  (confirm)="onConfirm()"
/>
